import { Row, Col } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { FC, useRef, forwardRef, useImperativeHandle, useEffect, useState, useContext, useMemo } from 'react';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { ChanceDetailModule, RelationCheckPointsModule, RelationSpotSurveysModule } from '@/common/components/business/ExpandStore/ts-config';
import { useMethods } from '@lhb/hook';
import { ModuleDetailsType } from '../type';
import { globalExpansionTaskAlias, isBottomOut } from '@/common/utils/ways';
import CoreInfomation from '../Modules/CoreInfomation/index';
import AreaScore from '../Modules/AreaScore';
import AsicsEstimateModule from '../Modules/AsicsEstimateModule';
import CheckSpotModule from '../Modules/CheckSpotModule';
import EarnEstimateModule from '../Modules/EarnEstimateModule';
import TabInfo from '../Modules/TabInfo';
import ChanceForm from '../Modules/ChanceForm/index';
import TaskBasic from '@/common/components/business/ExpandStore/TaskDeatil/components/TaskBasic';
import CircleBasicInfo from '@/common/components/business/ExpandStore/CircleBasicInfo';
import SemirTaskBasicInfo from '@/views/expandstore/pages/expansioncirclesenmatask/components/Detail/components/CircleBasicInfo';
import Overview from '../Modules/Overview';
import AreaProtect from '../Modules/AreaProtect';
import cs from 'classnames';
import UserInfoContext from '@/layout/context';
import styles from '../index.module.less';
import { useSelector } from 'react-redux';
import RelationCheckPoints from '../Modules/RelationCheckPoints';
import RelationSpotSurveys from '../Modules/RelationSpotSurveys';
import { ModelSyncOptions } from '../../modelSync';
import BidManagementModule from '../Modules/BidManagementModule';

/** 模块组件映射关系 采用map映射方便后期维护 添加/删除 模块*/
const moduleComponentMap = {
  [ChanceDetailModule.Basic]: CoreInfomation,
  [ChanceDetailModule.Footprint]: CheckSpotModule,
  [ChanceDetailModule.Asics]: AsicsEstimateModule,
  [ChanceDetailModule.Benifit]: EarnEstimateModule,
  [ChanceDetailModule.Radar]: AreaScore,
  [ChanceDetailModule.Detail]: TabInfo,
  [ChanceDetailModule.Task]: TaskBasic,
  [ChanceDetailModule.Overview]: Overview,
  [ChanceDetailModule.BidManagement]: BidManagementModule,
};

/** 模块组合详情 */
const DetailModules: FC<{
  detail,
  mainHeight?,
  canEditForm: boolean,
  isApproval?: boolean,
  approvalId?,
  onSearch?,
  updateHandle?,
  setHintStr,
  titleHeightRef,
  approvalScrollContainerRef?,
  isScrollContainer?: boolean,
  setHasEditableProperty?,
  wrapperClassName?: string,
  /** 禁用开店区域点击查看详情 */
  disabledArea?,
  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  shareData?,
  /** 当前区域保护特殊申请状态；未配置区域保护时保持 undefined。 */
  antiCollisionApprovalStatus?: number,
  /** 区域保护检测结果变更后，更新详情顶部操作 */
  onAreaProtectionCollisionChange?: (hasCollisionWithin200m: boolean | undefined) => void,
  /** 保存请求进行中时接管外层 Spin，避免重复点击保存/提交审批 */
  setLoading?: (loading: boolean) => void,
  ref?: any,
}> = forwardRef(({
  detail,
  mainHeight,
  canEditForm = false,
  isApproval = false,
  approvalId,
  onSearch,
  updateHandle,
  setHintStr,
  titleHeightRef,
  approvalScrollContainerRef,
  isScrollContainer = false,
  setHasEditableProperty,
  wrapperClassName = '',
  disabledArea, // 禁用开店区域点击查看详情
  shareData, // 分享时调用接口需要的数据，如果有值代表“分享时”
  antiCollisionApprovalStatus,
  onAreaProtectionCollisionChange,
  setLoading, // 保存请求进行中时接管外层 Spin
}, ref) => {
  // 外部调用保存机会点
  useImperativeHandle(ref, () => ({
    saveChance: (needCheck: boolean, cb: Function, shouldRefreshAfterSave = true) => {
      (chanceFormRef?.current as any)?.saveChance(needCheck, cb, shouldRefreshAfterSave);
    },
    updateModule: (onComplete?: (success: boolean) => void, options?: ModelSyncOptions) => {
      if (!(chanceFormRef?.current as any)?.updateModule) {
        onComplete?.(false);
        return;
      }
      (chanceFormRef.current as any).updateModule(onComplete, options);
    },
  }));
  // title高度 + tabs高度
  const titleHeight = titleHeightRef?.current || 0;
  const fixedHeight = titleHeight + 55.2; // 这里偷懒了，没有动态获取tabs的高度，所以不要随意进行tabs的自定义样式
  const chanceFormRef = useRef(null);
  const scrollContainerRef: any = useRef();
  const dynamicTabContentRefs: any = useRef([]);
  const dynamicTabActiveRef: any = useRef(''); // 同步动态表单组件tabActive
  const dynamicTabsRef: any = useRef([]); // 同步动态表单组件的tabs
  const { moduleDetails, checkSpots } = detail || {};
  const [dynamicTabsActive, setDynamicTabsActive] = useState<string>(''); // 动态表单详情组件tabs的active
  const { tenantInfo: { globalAliasItemVOs, taskTemplateEnable } } = useContext(UserInfoContext); // 租户信息
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);

  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const taskTemplateCode = tenantCheckData?.taskTemplateCode || '';

  /** 是否需要展示周边查询组件 */
  // const { moduleDetails, permissions } = detail || {};
  // const hasSurroundPermission = permissions?.some((item: PermissionsType) => item.event === 'surroundReport:pcEntrance');


  const moduleDetailsArray = useMemo(() => {
    /*
      过滤不展示的模块
      1、是否展示：不支持提交审批时，有配置就展示；支持审批时，模块可见时才展示
      supportDirectApproval 是否支持直接提交审批 1:支持 2:不支持
      2、特殊处理-tuodian任务模块：不启用tuodian任务，但又配置了任务模版，需要过滤
    */
    const arr = isArray(moduleDetails) ? moduleDetails.filter((module: any) => {
      return !(module.moduleType === ChanceDetailModule.Task && !taskTemplateEnable) &&
      (detail.supportDirectApproval === 2 || [1, 2].includes(module.isShow));
    }) : [];

    // 展示客流计数模块的判断，yht、展示动态表单详情模块、有关联的踩点点位
    const isYiHeTang = !!tenantCheckData?.isYiHeTang;
    const detailModuleIndex = arr.findIndex((module: any) => module.moduleType === ChanceDetailModule.Detail);
    const showRelationCheckpoints = isYiHeTang && (detailModuleIndex >= 0) && isArray(checkSpots) && checkSpots.length;
    if (showRelationCheckpoints) {
      arr.splice(detailModuleIndex, 0, RelationCheckPointsModule);
    }

    // 在动态表单模块后面插入踩点记录模块
    (detailModuleIndex >= 0) && arr.splice(detailModuleIndex + 1, 0, RelationSpotSurveysModule);
    return arr;
  }, [moduleDetails, checkSpots, tenantCheckData]);

  useEffect(() => {
    if (!moduleDetailsArray?.length) return;
    if (!(scrollContainerRef?.current || approvalScrollContainerRef?.current)) return;
    const realScrollContainerRef: any = approvalScrollContainerRef?.current || scrollContainerRef?.current;
    realScrollContainerRef && realScrollContainerRef.addEventListener('scroll', handleScroll);
    return () => realScrollContainerRef && (realScrollContainerRef.removeEventListener('scroll', handleScroll));
  }, [moduleDetailsArray]);

  const {
    handleScroll,
    renderModuleComponent,
  } = useMethods({
    /** 渲染模块组件 */
    renderModuleComponent(item: ModuleDetailsType) {
      item.id = detail.id; // 配置一个机会点id字段给每个模块，为后续组件调用接口直接使用

      if (item.moduleType === ChanceDetailModule.Detail && canEditForm) {
        // 表单支持直接编辑时
        return <ChanceForm
          key={item.moduleType + item.moduleTypeName}
          ref={chanceFormRef}
          id={detail.id}
          chanceDetail={detail}
          isApproval={isApproval}
          approvalId={approvalId}
          onSearch={onSearch}
          update={updateHandle}
          setHintStr={setHintStr}
          // -----------tabs长列表-------------
          // fixedHeight={fixedHeight}
          // 审批详情页和机会点详情公用，但是滚动元素不同
          container={approvalScrollContainerRef || scrollContainerRef}
          dynamicTabActiveRef={dynamicTabActiveRef}
          dynamicTabsRef={dynamicTabsRef}
          dynamicTabContentRefs={dynamicTabContentRefs}
          dynamicTabsActive={dynamicTabsActive}
          setDynamicTabsActive={setDynamicTabsActive}
          // ------------------------
          setHasEditableProperty={setHasEditableProperty}
          disabledArea={disabledArea}
          antiCollisionApprovalStatus={antiCollisionApprovalStatus}
          onAreaProtectionCollisionChange={onAreaProtectionCollisionChange}
          setLoading={setLoading}
        />;
      } else if (item.moduleType === ChanceDetailModule.Task) {
        return isNotEmptyAny(item.standardDirectTaskModule) ? (
          taskTemplateCode === 'clusterC' ? <SemirTaskBasicInfo
            taskDetail={item.standardDirectTaskModule}
            isChanceDetailModule={true}
            title={`${expansionTaskAlias || '拓店任务'}信息`}
          /> : <CircleBasicInfo
            title={`${expansionTaskAlias || '拓店任务'}信息`}
            taskDetail={item.standardDirectTaskModule}
          />
        ) : <TaskBasic
          key={item.moduleType + item.moduleTypeName}
          title={`${expansionTaskAlias || '拓店任务'}信息`}
          detail={item.standardTaskModule}
          open={true}
          shareData={shareData}
        />;
      } else if (item.moduleType === ChanceDetailModule.RelationCheckPoints) {
        return <RelationCheckPoints checkSpots={checkSpots}/>;
      } else if (item.moduleType === ChanceDetailModule.RelationSpotSurveys) {
        return <RelationSpotSurveys detail={detail}/>;
      }

      const Component = moduleComponentMap[item.moduleType];
      if (Component) {
        return <Component
          key={item.moduleType + item.moduleTypeName}
          data={item}
          fixedHeight={fixedHeight}
          container={approvalScrollContainerRef || scrollContainerRef}
          dynamicTabActiveRef={dynamicTabActiveRef}
          dynamicTabsRef={dynamicTabsRef}
          dynamicTabContentRefs={dynamicTabContentRefs}
          dynamicTabsActive={dynamicTabsActive}
          setDynamicTabsActive={setDynamicTabsActive}
          detail={item.moduleType === ChanceDetailModule.Basic ? detail : null}
          setHintStr={setHintStr}
          disabledArea={disabledArea}
          shareData={shareData}
          onAreaProtectionCollisionChange={onAreaProtectionCollisionChange}
        />;
      }
      return null;
    },


    // handleScroll: debounce(() => {
    handleScroll: () => {
      // 所有content此时距离顶部的距离，需要减去吸顶部分的高度（标题 + tabs高度）
      const offsets = dynamicTabContentRefs.current.map((refItem) => refItem?.el?.getBoundingClientRect()?.top - fixedHeight);
      // 当前tab内容所处的索引
      const activeIndex = offsets.findIndex((offset, index) => {
        const nextOffset = offsets[index + 1] || 0;
        return offset <= 0 && nextOffset > 0;
      });
      // // 当前点击tab时，查看当前点击的tab距离顶部的距离
      const targetIndex = dynamicTabContentRefs.current.findIndex((item) => item.key === dynamicTabActiveRef.current);
      const targetOffset = targetIndex !== -1 ? offsets[targetIndex] : 0;
      if (activeIndex !== -1 && dynamicTabsRef.current?.[activeIndex]) {
        // 滚动条已经滚动到底，但是可视区域顶部还在其他tab内容区域下（最后的几个tab可能内容很少，出现在一屏）
        if (isBottomOut(scrollContainerRef.current) && targetOffset > 0) {
          setDynamicTabsActive(dynamicTabActiveRef.current);
          return;
        };
        const target = dynamicTabContentRefs.current[activeIndex];
        target && target.key && setDynamicTabsActive(target.key);
      }
    }
    // }, 50),
  });

  return <>
    { moduleDetailsArray.length || detail?.protectInfo?.approvalId || tenantCheckData?.isYiMing ? (
      <div
        ref={scrollContainerRef}
        className={cs('pb-24', styles.detailModulesWrapper, wrapperClassName)}
        style={isScrollContainer ? {
          height: mainHeight || 'auto',
          overflowY: 'scroll',
          overflowX: 'hidden',
        } : {}}
      >
        {/* 区域保护模块，0708和产品沟通，暂无往saas后台配置模块控制显示与否的想法 */}
        {detail?.protectInfo?.approvalId
          ? <AreaProtect detail={detail}/>
          : <></>}

        {/* 模块组件 */}
        {tenantCheckData?.isYiMing && <Row gutter={24} className='pt-16'>
          <Col span={12}>
            <V2DetailItem label='所属加盟商' value={detail?.franchiseeName || '-'} />
          </Col>
        </Row>}
        {moduleDetailsArray.map((item: ModuleDetailsType) => renderModuleComponent(item))}

      </div>
    ) : <></>}
  </>;
});

export default DetailModules;
